export const ESTADOSPOTENCIALES = [
    {
        nombre: 'Nuevo',
        color: '#DFA41A'
    },
    {
        nombre: 'Contactado',
        color: '#32993D'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },
]

export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: '#DFA41A'
    },
    {
        nombre: 'Admin',
        color: '#32993D'
    },
    {
        nombre: 'Suspendido',
        color: '#808080'
    },
]

export const ORIGENPOTENCIALES = ['Formulario', 'Chat', 'Externo']

export const COLORESESTADOS = ['#DFA41A', '#376F3C', '#32993D']